function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("path", {
  d: "M49.93 30.601c1.786 5.36-9.997 9.825-22.329 9.825S3.485 35.96 5.272 30.601c1.092-3.276 10.093.785 22.426.785 12.332 0 21.141-4.06 22.233-.785z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.185 30.659c-2.826-1.815-4.246-3.99-3.473-6.31 1.266-3.798 11.702.91 26 .91s24.51-4.708 25.775-.91c.774 2.32-.647 4.496-3.476 6.312"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 22.9c-.033-.436.02-.78.164-1.23 1.048-3.276 9.69.785 21.529.785s20.296-4.061 21.344-.785c.14.44.194.774.166 1.2"
})), /*#__PURE__*/React.createElement("path", {
  d: "M4.363 27.029s2.099-2.89 3.573-2.68 1.206 3.363 2.68 3.573c1.473.21 2.098-2.89 3.572-2.68s1.206 3.363 2.68 3.573c1.473.21 2.098-2.89 3.572-2.68 1.474.211 1.195 3.468 2.68 3.574 1.68.119 2.68-3.182 4.037-3.216 1.321-.033 2.357 3.335 4.037 3.216 1.485-.106 1.206-3.363 2.68-3.573 1.474-.21 2.099 2.89 3.573 2.68 1.473-.211 1.205-3.363 2.679-3.573 1.474-.21 2.099 2.89 3.573 2.68 1.473-.211 1.206-3.363 2.68-3.573s3.572 2.679 3.572 2.679"
}), /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11.662,
  cy: 33.119,
  r: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18.043,
  cy: 35.881,
  r: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36.805,
  cy: 36.11,
  r: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45.262,
  cy: 32.662,
  r: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27.305,
  cy: 35,
  r: 1
})));

var SvgHotdog = function SvgHotdog(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHotdog, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Hotdog.dbf982db.svg";
export { ForwardRef as ReactComponent };